/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ChangeMiscSettingsMutationRequest,
  ChangeMiscSettingsMutationResponse,
  ChangeMiscSettingsPathParams,
  ChangeMiscSettings400,
} from '../types/ChangeMiscSettings'

function getChangeMiscSettingsUrl({
  key,
}: {
  key: ChangeMiscSettingsPathParams['key']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/preferences/misc-settings/update/${key}/` as const,
  }
  return res
}

/**
 * @summary Update a misc setting for the current company
 * {@link /api/v1/preferences/misc-settings/update/:key/}
 */
export async function changeMiscSettings(
  { key }: { key: ChangeMiscSettingsPathParams['key'] },
  data: ChangeMiscSettingsMutationRequest,
  config: Partial<RequestConfig<ChangeMiscSettingsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ChangeMiscSettingsMutationResponse,
    ResponseErrorConfig<ChangeMiscSettings400>,
    ChangeMiscSettingsMutationRequest
  >({
    method: 'POST',
    url: getChangeMiscSettingsUrl({ key }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
